import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoaderService } from 'src/app/service/loader.service';
import { combineLatest, map, Observable, Subscription } from 'rxjs';
import { CalculatorLoaderService } from 'src/app/service/calculator-loader.service';

@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class LoaderComponent implements OnInit, OnDestroy {
 
 premiumCnts: string[] = [
    "We are currently calculating the premium to generate the most accurate quotation for you.",
    "Your premium is being calculated to ensure the most competitive quotation is displayed.",
    "We are working on calculating the premium to present the best possible quotation for your needs.",
    "The premium calculation is underway to deliver a detailed and tailored quotation."
  ]
  loading$ : any;
  loading: boolean = false;  // Track loading state manually
  private loadingSubscription: Subscription;  // To store the subscription and clean up
  private calculatorLoadingSubscription: Subscription; 
  premiumCnt: string;
  private currentCntIndex = 0;
  private intervalId: any;
  gifLoading$: any;
  content$: any;
  combinedLoader$: Observable<'calculator' | 'default' | null>;
  constructor(private loaderService: LoaderService,private calculatorLoaderService: CalculatorLoaderService) {
    this.loading$ = this.loaderService.loading$;
    this.gifLoading$ = this.calculatorLoaderService.loading$; // Observing the loader state
  this.content$ = this.calculatorLoaderService.content$; // Observing the dynamic content
 
  }

  
  ngOnInit(): void {
    this.loaderService.show();
    // Perform long-running operation
    this.loaderService.hide();
    this.combinedLoader$ = combineLatest([
      this.loaderService.loading$,
      this.calculatorLoaderService.loading$
    ]).pipe(
      map(([defaultLoading, calculatorLoading]) => {
        if (calculatorLoading) return 'calculator';
        if (defaultLoading) return 'default';
        return null;
      })
    );
  
    // Subscribe to the loading$ observable to manage loading state manually
    this.loadingSubscription = this.loaderService.loading$.subscribe((loading: boolean) => {
      setTimeout(() => {
        //this.loading = loading;  // Update local loading state in the next event loop cycle
      });
    });
    this.calculatorLoadingSubscription =  this.calculatorLoaderService.loading$.subscribe((loading) => {
      if (loading) {
        this.startPremiumContentRotation();
      } else {
        this.stopPremiumContentRotation();
      }

    });
  }
  startPremiumContentRotation(): void {
    this.premiumCnt = this.premiumCnts[this.currentCntIndex];
    this.intervalId = setInterval(() => {
      this.currentCntIndex = (this.currentCntIndex + 1) % this.premiumCnts.length;
      this.premiumCnt = this.premiumCnts[this.currentCntIndex];
    }, 2000); // Update content every second
  }

  stopPremiumContentRotation(): void {
    clearInterval(this.intervalId); // Stop the content rotation
    this.premiumCnt = ''; // Clear the content
    this.currentCntIndex = 0; // Reset the index
  }
  ngOnDestroy(): void {
    // Clean up the subscription to prevent memory leaks
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
    if (this.calculatorLoadingSubscription){
      this.calculatorLoadingSubscription.unsubscribe();
    }
  }
}
